import { Injectable, inject } from "@angular/core";
import { Messaging, getToken } from "@angular/fire/messaging";
import { Router } from "@angular/router";
import { getAuth, type Auth, type User } from "@angular/fire/auth";
import { NotificationsTokensService } from "../api-service/notifications-tokens.service";

@Injectable({
  providedIn: "root",
})
export class PushNotificationService {
  private readonly messaging: Messaging = inject(Messaging);
  private readonly router: Router = inject(Router);
  private readonly notificationsTokensService: NotificationsTokensService = inject(NotificationsTokensService);

  private lastOperationPromise: Promise<void> = Promise.resolve();
  private token!: string;
  private currentRoute: string = "";

  private async getCurrentRoute(): Promise<void> {
    this.currentRoute = this.router.url;
  }

  private async createNotificationsToken(): Promise<void> {
    try {
      const auth: Auth = getAuth();
      const user: User | null = auth.currentUser;
      if (!user) return;

      await this.notificationsTokensService.createNotificationsToken(this.token);
    } catch (error: unknown) {
      // No fatal: sin token el usuario simplemente no recibe push.
      console.warn("No se pudo registrar el token de notificaciones", error);
    }
  }

  private tokenWait(): void {
    const intervalId: number = window.setInterval(async () => {
      this.lastOperationPromise = this.lastOperationPromise
        .then(() =>
          this.getToken(() => {
            this.createNotificationsToken();
            window.clearInterval(intervalId);
          })
        )
        .catch(() =>
          this.getToken(() => {
            this.createNotificationsToken();
            window.clearInterval(intervalId);
          })
        );
    }, 5000);

    window.setTimeout(() => {
      window.clearInterval(intervalId);
    }, 1000 * 60);
  }

  private async getToken(callback: () => void = () => {}): Promise<void> {
    try {
      const token: string = await getToken(this.messaging);
      if (typeof token === "string") {
        this.token = token;
        callback();
      }
    } catch (error: unknown) {
      // No fatal: ocurre si el navegador no soporta push o el permiso esta denegado.
      console.warn("No se pudo obtener el token de Firebase Messaging", error);
    }
  }

  public async cloudMessaging(): Promise<void> {
    await this.getCurrentRoute();

    if (this.currentRoute === "/logout") return;

    try {
      const permission: NotificationPermission = await Notification.requestPermission();
      if (permission === "granted") {
        this.tokenWait();
      }
    } catch (error: unknown) {
      // No fatal: algunos navegadores lanzan si la API no esta disponible.
      console.warn("No se pudo solicitar el permiso de notificaciones", error);
    }
  }
}
